import { render } from "./ProduitColisPostaux.vue?vue&type=template&id=e734d482&scoped=true&ts=true"
import script from "./ProduitColisPostaux.vue?vue&type=script&lang=ts"
export * from "./ProduitColisPostaux.vue?vue&type=script&lang=ts"

import "./ProduitColisPostaux.vue?vue&type=style&index=0&id=e734d482&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e734d482"]])

export default __exports__